export default "__VITE_ASSET__BRpl$V1k__"